import type { ICollectionStats } from '@repo/sdk';

export type CollectionMasteryItem = ICollectionStats & {
  totalChallenges?: number;
  reviewedChallenges?: number;
};

interface ICollectionProgress {
  pct: number;
  fraction: string | null;
}

export function getCollectionProgress(c: CollectionMasteryItem): ICollectionProgress {
  const { totalChallenges, reviewedChallenges } = c;
  if (typeof totalChallenges === 'number' && typeof reviewedChallenges === 'number') {
    const pct =
      totalChallenges > 0
        ? Math.min(100, Math.round((reviewedChallenges / totalChallenges) * 100))
        : 0;
    return { pct, fraction: `${reviewedChallenges}/${totalChallenges}` };
  }

  const reviewedEvents = c.totalPassed + c.totalFailed + c.totalSkipped;
  const pct = reviewedEvents > 0 ? Math.round((c.totalPassed / reviewedEvents) * 100) : 0;
  return { pct, fraction: null };
}
